<template>
  <div class="wrapper">
      <label v-if="label" >{{label}}</label>
      <b-input-group>
         <autocomplete 
                :source="uri"
                :placeholder="place"
                :input-class-required="classeRequired"
                results-display="CODIGONOME"
                results-value="ID"
                :disableInput="desabilitarInput"
                @selected="onSelecionado"
                @input="setId"
                @clear="clearComplete({})" 
                ref="auto">
          </autocomplete>
          <b-input-group-append v-if="!desabilitarInput">
            <b-btn variant="primary" v-b-modal="idModal">{{labelBotao}}
              <i class="fa fa-ellipsis-h"></i></b-btn>
          </b-input-group-append>
      </b-input-group>
    <b-modal :id="idModal"
             scrollable
             ref="modalProduto"
             title="Pesquisar Bens"
             class="modal-primary"
             size="xl"
             ok-title="Fechar"
             ok-only
             @shown="clearModal">
      <b-card>
      <form @submit.stop.prevent="handleSubmit">
        <!-- <b-form-input type="text" placeholder="Enter your name" v-model="resultado"></b-form-input> -->
        <b-row>
          <!--/.col-->
          <b-col sm="6">
                <b-form-input type="text" id="edNomePesquisaModalBens" ref="edNomePesquisaModalBens" placeholder="Informe o Nome" v-model="pesquisa.nome"> </b-form-input>
          </b-col>
          <b-col sm="4">
            <!-- Button -->
            <b-button  type="submit" variant="primary" @click.stop.prevent="onSubmit()">
              <span>Pesquisar</span>
            </b-button> 
            <!-- Button -->
            <b-button type="reset"  variant="danger">
                  <i class="fa fa-ban"></i> Limpar
            </b-button>
          </b-col>
          <b-col sm="2" class="d-flex align-items-end">
            <b-pagination class=" mb-0 bg-gray-100" :limit="2"  :total-rows="items.length" :per-page="perPage" v-model="currentPage" />
          </b-col>
        </b-row>
      </form>
      </b-card>
      <b-row  v-if="this.items.length &&  this.items.length > 0">
        <b-col sm="12">
            <!-- Main table element -->
            <b-table 
                    striped 
                    hover 
                    sticky-header="true"
                    head-variant="dark"
                    responsive 
                    small
                    :busy.sync="isBusy" 
                    :items="items" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @row-clicked="selecionar">
              <template #cell(ID)="item">{{item.item.ID}}</template>
              <template #cell(NOME)="item">{{item.item.NOME}}</template>
            </b-table>
            
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template> 
<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import Autocomplete from '../componentes/Autocomplete'

export default {
  props: {
    label: String,
    place: String,
    labelBotao: String,
    idInicial: Number,
    classeRequired: Boolean,
    desabilitarInput: Boolean,
    idModal: {
      type: String,
      default() {
        return `modal-produto-${Math.random().toString(36).substr(2, 9)}`
      }
    }
  },
  data () {
    return {
      resultado: '',
      pesquisa: {
        id: '',
        nome: ''
      },
      isLoading: false,
      status: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "ID",
          label: 'Código', 
          class: 'my-left-border my-left-right my-left-bottom align-middle text-right',  
          sortable: true 
        },
        {
          key: "NOME",
          label: 'Nome', 
          class: 'my-left-border my-left-right my-left-bottom align-middle',  
          sortable: true 
        },
        {
          key: "QUANT_ESTOQUE",
          label: 'Estoque', 
          class: 'my-left-border my-left-right my-left-bottom align-middle text-right',
          formatter: (value) => value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : '-',
          sortable: true 
        },
        {
          key: "VL_CUSTO",
          label: 'Custo Unit.', 
          class: 'my-left-border my-left-right my-left-bottom align-middle text-right font-weight-bold',
          formatter: (value) => value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'Sem custo',
          sortable: true 
        }
      ],
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      uri: this.$http.defaults.baseURL.concat('api/protected/bens/autocomplete?&texto='),
      classeBorda: 'teste'
    }
  },
  components: {
    VueButtonSpinner,
    Autocomplete
  },
  methods: {
    setId (evt) {
      this.$emit('retornaId', evt)
    },
    clearComplete (obj) {
      this.$emit('retornaId', null)
      this.$emit('retornaNome', null)
      this.$emit('retornaCusto', 0)
    },
    clearModal () {
      this.items = []
      this.pesquisa.id = ''
      this.pesquisa.nome = ''
      this.$refs.edNomePesquisaModalBens.focus()
    },
    selecionar (evt) {
      const nomeDisplay = evt.CODIGONOME || evt.NOME_COMPLETE || (evt.CODIGO + ' - ' + evt.NOME)
      this.$emit('retornaId', evt.ID || evt.CODIGO)
      this.$emit('retornaNome', nomeDisplay)
      this.$emit('retornaCusto', evt.VL_CUSTO || 0)
      this.clearModal()
      this.$refs.modalProduto.hide()
      // Mudar o display do autocomplete..
      this.$refs.auto.display = nomeDisplay
    },
    onSubmit () {
      if ((!this.pesquisa.id) && (!this.pesquisa.nome)) {
        alert('Por Favor! Informe algum texto/valor para pesquisar')
        return
      }
      this.isLoading = true
      this.isBusy = true
      let uri = `/api/protected/bens/localizar?idPesquisa=${this.pesquisa.id}&nomePesquisa=${this.pesquisa.nome}`
      let promise = this.$http.get(uri)
      return promise.then((data) => {
        this.items = data.data
        this.isBusy = false
        this.isLoading = false
        this.status = true // or success
        setTimeout(() => {
          this.status = ''
        }, 1000) // to clear the status :)
      }).catch((error) => {
        if (error) {
          this.items = []
          this.isLoading = false
          this.status = false // or error
        }
      })
    },
    atualizaComplete () {
      if (this.idInicial) {
        let uri = `/api/protected/bens/pesquisaridmin?idPesquisa=${this.idInicial}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          this.$refs.auto.display = data.data[0].CODIGONOME
          this.$refs.auto.selectedDisplay = data.data[0].CODIGONOME
          this.$refs.auto.value = data.data[0].ID
        })
      }
    },
    atualizaClasse () {
      if (this.classe === '0') {

      }
    },
    onSelecionado({ selectedObject }) {
      if (selectedObject) {
        this.$emit('retornaId', selectedObject.ID)
        this.$emit('retornaNome', selectedObject.CODIGONOME)
        this.$emit('retornaCusto', selectedObject.VL_CUSTO)

        // Atualiza visualmente o campo (opcional)
        this.$refs.auto.display = selectedObject.CODIGONOME
        this.$refs.auto.selectedDisplay = selectedObject.CODIGONOME
        this.$refs.auto.value = selectedObject.ID
      }
    },
  },
  watch: {
    // escuta o idInicial para pesquisar o cliente se o cadastro tiver cliente_id por exemplo
    'idInicial': function () {
      this.atualizaComplete()
    }
  },
  created () {
    this.atualizaComplete()
  }
}
</script>
<style>
.modal-dialog {
  top: 50px
}
.botao{
  /*
  border-radius: 0;
  border: 2px solid #20a8d8;
  */
}
.b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
}
.b-table .my-left-right {
  border-right: 1px solid #a4b7c1;
}
.b-table .my-left-bottom {
  border-bottom: 1px solid #a4b7c1;
}
</style>



// WEBPACK FOOTER //
// src/views/pesquisa/BensPesquisa.vue